import { combineReducers, createStore, applyMiddleware, Middleware } from "redux";
import { Dispatch, Store, compose } from 'redux';
import { appReducer } from './app.reducer';
import { onAction } from './effects';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: (...middleware: any[]) => any;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers({ app: appReducer });
export const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(effect as Middleware),
));
export const dispatch = store.dispatch;

export function effect(reduxStore: Store<any>){
  return (next: Dispatch<any>) => {
    return (action: {type: string, payload: any}) => {
      // let the orignial action keep going
      next(action);

      onAction(reduxStore.getState(), action, dispatch);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/index.tsx